import React, { useState, useEffect } from "react";
import { get, isEmpty, isNull } from "lodash";
import TargetDroppedOutputField from "../../containers/Mapper/MapAndTransformOutput/TargetDroppedOutputField";
import { UnmappedFieldOutput } from "./../../containers/Mapper/MapAndTransformOutput/UnMappedFieldOutput";
import SliderPanel from "../SliderPanel";
import ClickToSelectFunctionSlider from "../../containers/Mapper/MapAndTransformOutput/ClickToSelectFunctionSlider";
import SourceCollectionsFilter from "../SourceCollectionsFilter";

const FieldDragandDropComponent = (props) => {
  const {
    index,
    values,
    objName,
    fieldName,
    isAdded,
    onDeleteClick,
    setFieldValue,
    setClickToSelect,
    clickToSelect,
    setFieldArrayName,
    forFunction = false,
    isCollection = false,
    headerError,
    valueError,
  } = props;

  const data = isNull(index)
    ? get(values, `${objName}`, {})
    : get(values, `${fieldName}`, {});

  const dataValue = data.value;
  const propertyName = get(dataValue, "propertyName", "");
  const propertyNameParent = get(dataValue, "propertyNameParent", "");

  const [dataTypeMisMatch, setDataTypeMisMatch] = useState(false);
  const [openSlider, setOpenSlider] = useState(false);
  const [showSlider, setShowSlider] = useState(false);

  useEffect(() => {
    setDataTypeMisMatch(
      data?.value?.dataType != undefined && data?.dataType != undefined
        ? data?.dataType != data?.value?.dataType
          ? true
          : false
        : false
    );
  }, [data]);

  const mappedData = isNull(index)
    ? get(values, `${objName}.value`, {})
    : get(values, `${fieldName}.value`, {});
  return (
    <div className="mw-100">
      {isEmpty(mappedData?.path) ? (
        <UnmappedFieldOutput
          openSlider={openSlider}
          setOpenSlider={setOpenSlider}
          index={index}
          forFunction={forFunction}
          fieldName={fieldName}
          objName={objName}
          isAdded={isAdded}
          onDeleteClick={onDeleteClick}
          id={mappedData?.propertyName}
          setFieldArrayName={setFieldArrayName}
          setClickToSelect={setClickToSelect}
          headerError={headerError}
          valueError={valueError}
        />
      ) : (
        <TargetDroppedOutputField
          isOutput={true}
          index={index}
          objName={objName}
          fieldName={fieldName}
          mappedData={mappedData}
          dataTypeMisMatch={dataTypeMisMatch}
          forFunction={forFunction}
          setFieldValue={setFieldValue}
          setFieldArrayName={setFieldArrayName}
          setClickToSelect={setClickToSelect}
          clickToSelect={clickToSelect}
          isCollection={isCollection}
        />
      )}

      <SliderPanel
        isMapper={true}
        isOpen={openSlider}
        showCancelButton={false}
        showSave={false}
        showCancel={true}
        onClose={() => {
          setOpenSlider(false);
        }}
        size={30}
      >
        <ClickToSelectFunctionSlider
          objName={objName}
          setShowSlider={setShowSlider}
          openSlider={openSlider}
          setOpenSlider={setOpenSlider}
          fieldName={fieldName}
          index={index}
          showSlider={showSlider}
        />
      </SliderPanel>

      <SourceCollectionsFilter
        setShowSlider={setShowSlider}
        showSlider={showSlider}
        fieldName={
          isNull(index)
            ? `${objName}.value`
            : fieldName == ""
            ? `${objName}.${fieldName}value`
            : `${fieldName}value`
        }
        propertyName={propertyName}
        collectionName={propertyNameParent}
      />
    </div>
  );
};

export default FieldDragandDropComponent;
